import { encodeBase64 } from "../../utils/utilityFunctions";
import { CALL_API } from "../middleware";
import { ALTERNATIVE_ASSET_ALLOCATION_FAILURE, ALTERNATIVE_ASSET_ALLOCATION_SUCCESS, AlternativeAssetAllocationRes, AlternativeSchemeRes, FUNDHOUSE_FAILURE, FUNDHOUSE_SUCCESS, FundHouseApiRes, TOPFIVE_FAILURE, TOPFIVE_SUCCESS, TopFiveApiRes } from "../types/alternative";
import { TOTAL_CARD_VALUES, TOTAL_CARD_VALUES_SUCCESS, TotalCardValuesReq, TotalCardValuesRes } from "../types/products";

export const totalAlternateCardValuesApi =
    (body: TotalCardValuesReq) =>
        async (dispatch: any): Promise<TotalCardValuesRes> => {
            return await dispatch({
                [CALL_API]: {
                    // enableFixture: true,
                    json: 'alternativeTotal.json',
                    url: `/onboarding/dashboard/totalValues`,
                    method: 'POST',
                    types: [TOTAL_CARD_VALUES_SUCCESS, TOTAL_CARD_VALUES],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const AlternateAssetAllocationApi =
    (body: any) =>
        async (dispatch: any): Promise<AlternativeAssetAllocationRes> => {
            return await dispatch({
                [CALL_API]: {
                    enableFixture: false,
                    json: 'alternativeAssetAllocation.json',
                    url: `/onboarding/dashboard/categoryWiseDistribution`,
                    method: 'POST',
                    types: [ALTERNATIVE_ASSET_ALLOCATION_SUCCESS, ALTERNATIVE_ASSET_ALLOCATION_FAILURE],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };


export const FundHouseApi =
    (body: any) =>
        async (dispatch: any): Promise<FundHouseApiRes> => {
            return await dispatch({
                [CALL_API]: {
                    enableFixture: false,
                    json: 'fundhouse.json',
                    url: `/onboarding/dashboard/fundHousePerformance`,
                    method: 'POST',
                    types: [FUNDHOUSE_SUCCESS, FUNDHOUSE_FAILURE],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
export const topfiveApi =
    (body: any) =>
        async (dispatch: any): Promise<TopFiveApiRes> => {
            return await dispatch({
                [CALL_API]: {
                    enableFixture: false,
                    json: 'topfive.json',
                    url: `/onboarding/dashboard/topSchemes`,
                    method: 'POST',
                    types: [TOPFIVE_SUCCESS, TOPFIVE_FAILURE],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };
export const schemeDetails =
    (body: any) =>
        async (dispatch: any): Promise<AlternativeSchemeRes> => {
            return await dispatch({
                [CALL_API]: {
                    // enableFixture: false,
                    // json: 'topfive.json',
                    url: `/onboarding/dashboard/schemeDetails`,
                    method: 'POST',
                    types: [TOPFIVE_SUCCESS, TOPFIVE_FAILURE],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };